export const dataLayerPush = (data: any) => {
    window.dataLayer = window.dataLayer ?? [];
    window.dataLayer?.push(data);
};

export const dataLayerPushPageView = () => {
    dataLayerPush({
        event: 'ga.page',
        location: window.location.href,
        path: window.location.pathname,
        title: document.title,
        referrer: document.referrer,
    });
}
